import { fetch } from '@atlassian/eoc-fetch';
import { generateLogParams, postProcessLogsSearch } from '../../../common/utils';
export const fetchLogs = async params => {
  const urlParams = generateLogParams(params);
  return fetch('/v1/logs/search?' + urlParams.toString()).then(response => postProcessLogsSearch(urlParams, response));
};